module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/hero-exam-c020c154cd1fc51d7170428d7fb10d32.webp";